import React from 'react';
import loadingIcon from '../ShiftyPM_Loading.svg';

export default function RouteSuspenseFallback() {
  return (
    <div className="suspense-loader">
      <img src={loadingIcon} alt="Loading..." />
    </div>
  );
}
